import styled from "styled-components";

export const Container = styled.div`
  width: 400px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.COLORS.PRIMARY};
  cursor: pointer;
  margin-top: 30px;

  @media (max-width: 360px) {
         width: 90%;
    }
      @media (max-width: 768px) {
         width: 90%;
    }
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.COLORS.TITLE};
  font-size: 20px;
  font-weight: 700;
  margin: 0;

    @media (max-width: 360px) {
         text-align: center;
    }
      @media (max-width: 768px) {
        text-align: center;
    }
`;